import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setAPIFailed } from 'features/order-tracker/store/actions';
import { Loader } from './components/Loader';
import { ProgressList } from './components/ProgressList';
import { ProgressBar } from './components/ProgressBar/ProgressBar';
import {
  TITLE,
  MAX_LOADING_TIME,
  ERROR_MESSAGE,
  INFO_MESSAGE,
} from './constants';

import styles from './styles.module.scss';

export const LoadingIndicator: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timerId = setTimeout(() => {
      dispatch(setAPIFailed({
        isGeneralAPIFailed: true,
        isFetching: false,
        errorMessage: ERROR_MESSAGE,
      }));
    }, MAX_LOADING_TIME);
    return () => clearTimeout(timerId);
  }, []);

  return (
    <div className={styles.loadingHolder}>
      <h1>{TITLE}</h1>
      <div className={styles.loaderAnimationWrapper}>
        <Loader />
      </div>
      <div className={styles.progressBar}>
        <ProgressList />
      </div>
      <ProgressBar />
      <div className={styles.messageBox}>
        <h3>{INFO_MESSAGE}</h3>
      </div>
    </div>
  );
};
